<template>
  <div style="min-width:280px; max-width:400px;" class="flex-grow-1">
    <v-form ref="form" v-model="valid" @submit.prevent="submitEmailAddress">
      <v-card elevation="10">
        <v-overlay absolute :value="isProcessing" opacity=".6">
          <v-row justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
          <v-row justify="center">
            Working on it...
          </v-row>
        </v-overlay>
        <v-toolbar
          style="border-top-left-radius: 4px; border-top-right-radius: 4px;"
          color="info white--text"
          flat
          short>
          <v-toolbar-title>
            <v-icon color="white">mdi-lock</v-icon>
            Begin Log In
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text style="min-height:182px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-alert
                v-show="isLoginError"
                type="error"
                icon="mdi-alert-circle-outline"
                dense
                v-on="on">
                Sorry, that didn't work. Please try again.
              </v-alert>
            </template>
            <span>{{ errorMessage }}</span>
          </v-tooltip>
          <div class="text-center">
            Type your email address below to start your login.
          </div>
          <v-text-field
            v-model="emailAddress"
            class="mt-5"
            label="Email Address"
            :placeholder="emailPlaceholder"
            :rules="emailRules"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            outlined
            required
            autofocus
          ></v-text-field>
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-end">
          <v-btn color="primary" :disabled="!valid || isProcessing" @click="submitEmailAddress">
            <v-icon class="mr-2">mdi-chevron-right</v-icon>
            Continue
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'LoginEmailAddress',

  props: {
    isLoginError: {
      type: Boolean,
      default () {
        return false
      }
    },
    errorMessage: {
      type: String,
      default: null
    },
    restoreEmailAddress: {
      type: String,
      default: null
    }
  },
  data: () => ({
    valid: false,
    isProcessing: false,
    emailAddress: '',
    emailRules: [
      v => !!v || 'Email address is required.',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
    ]
  }),
  computed: {
    emailPlaceholder () {
      return `first.last@${process.env.VUE_APP_CUSTOMER_EMAIL_DOMAIN}`
    }
  },
  mounted () {
    if (this.restoreEmailAddress) {
      this.emailAddress = this.restoreEmailAddress
    }
  },
  methods: {
    submitEmailAddress () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.isProcessing = true
      this.$emit('emailAddressSubmitted', this.emailAddress)
      this.$router.push({
        name: 'LoginContactType',
        params: {
          emailAddress: this.emailAddress
        }
      }).catch(() => {})
    },
    validate () {
      this.$refs.form.validate()
    }
  }
}
</script>
